import { createSlice } from '@reduxjs/toolkit';
import { LABELGENAPI} from '../../../API';
import { logFrontendActivity } from '../../General/activityLogger';

export const timezoneslice = createSlice({
    name: 'timezone',
    initialState: {
        data: [],
        meta: [],
        loading: false,
        hasErrors: false,
        notification: { show: false, messageContent: "", messageType: "success" }
    },
    reducers: {
        getTimezoneData: (state) => {
            return {
                ...state,
                loading: true,
                hasErrors: false
            }
        },
        getTimezoneDataSuccess: (state, action) => {
            return {
                ...state,
                data: action && action.payload && action.payload.data && action.payload.data.data,
                notification: { show: true, messageContent: [action && action.payload && action.payload.data && action.payload.data.message], messageType: "success" },
                hasErrors: false,
                loading: false
            }
        },
        getTimezoneDataFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: true,
                notification: { show: true, messageContent: [action && action.payload && action.payload.data && action.payload.data.message], messageType: "error" }
            }
        },
        postTimezoneData: (state) => {
            return {
                ...state,
                loading: true,
                hasErrors: false
            }
        },
        postTimezoneDataSuccess: (state, action) => {
            return {
                ...state,
                hasErrors: false,
                loading: false,
                notification: { show: true, messageContent: [action && action.payload && action.payload.data && action.payload.data.message], messageType: "success" }
            }
        },
        postTimezoneDataFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: true,
                notification: { show: true, messageContent: [action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message], messageType: "error" }
            }
        },
        putTimezoneData: (state) => {
            return {
                ...state,
                loading: true,
                hasErrors: false
            }
        },
        putTimezoneDataSuccess: (state, action) => {
            return {
                ...state,
                hasErrors: false,
                loading: false,
                notification: { show: true, messageContent: [action && action.payload && action.payload.data && action.payload.data.message], messageType: "success" }
            }
        },
        putTimezoneDataFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: true,
                notification: { show: true, messageContent: [action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message], messageType: "error" }
            }
        },
        deleteTimezoneData: (state) => {
            return {
                ...state,
                loading: true,
                hasErrors: false
            }
        },
        deleteTimezoneDataSuccess: (state, action) => {
            return {
                ...state,
                hasErrors: false,
                loading: false,
                notification: { show: true, messageContent: [action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message], messageType: "success" }
            }
        },
        deleteTimezoneDataFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: true,
                notification: { show: true, messageContent: [action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.message], messageType: "error" }
            }
        },

        resetTimezone: (state) => {
            return {
                ...state,
                loading: false,
                hasError: false,
                notification: { show: false, messageContent: "", messageType: "success" }
            }
        },


    }
})
export const { getTimezoneData, getTimezoneDataSuccess, getTimezoneDataFailure, postTimezoneData, postTimezoneDataSuccess, postTimezoneDataFailure,
    putTimezoneData, putTimezoneDataSuccess, putTimezoneDataFailure,
    deleteTimezoneData, deleteTimezoneDataSuccess, deleteTimezoneDataFailure,resetTimezone } = timezoneslice.actions;


export const fetchTimezoneData = () => dispatch => {
    dispatch(getTimezoneData());
    try {
        LABELGENAPI
            .get("/settings/timezone-settings")
            .then(function (response) {
                dispatch(getTimezoneDataSuccess(response));
            })
            .catch(function (error) {
                dispatch(getTimezoneDataFailure(error.response));
            });
    } catch (error) {
        dispatch(getTimezoneDataFailure());
    }
};

export const storeTimezoneData = (userid,data) => dispatch => {
    dispatch(postTimezoneData());
    const logRef = crypto.randomUUID();
    try {
        LABELGENAPI.post('/settings/timezone-settings', data, { 
            headers: { 
                'x-log-ref': logRef
                 } 
            })
            .then(function (response) {
                dispatch(postTimezoneDataSuccess(response));
                dispatch(fetchTimezoneData());
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'TIMEZONE',
                    action: 'SUCCESS',
                    request_data: data,
                    response_data: response.data,
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }else{
                        console.log('Activity log failed:', ref);
                    }
                });
            }).catch(function (error) {
                dispatch(postTimezoneDataFailure(error.response));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'TIMEZONE',
                    action: 'FAILURE',
                    request_data: data,
                    response_data: error.response?.data || {},
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }
                });
            })
    }
    catch (error) {
        dispatch(postTimezoneDataFailure(error.response));
        logFrontendActivity({
            group: 'SETTINGS',
            subgroup: 'TIMEZONE',
            action: 'FAILURE',
            request_data: data,
            response_data: error.response?.data || {},
            log_ref: logRef,
            userid: userid
        }).then((ref) => {
            if (ref) {
                console.log('Activity log recorded with log_ref:', ref);
            }
        });
    }
}

export const resetTimezoneState = data => dispatch => {
    dispatch(resetTimezone());
}

export default timezoneslice.reducer;
